import React from 'react';
import { FaUserShield } from 'react-icons/fa';
import { MdOutlineGeneratingTokens, MdOutlinePending, MdAutorenew, MdDone } from 'react-icons/md';
import RequestStatsDashboard from 'components/app/account-management/shared/RequestStatsDashboard';
import { getRequestUserAccounts } from 'redux/request/userAccountSlice';

const STATUS_CARDS = [
  { key: 'total',       label: 'Total Requests', icon: MdOutlineGeneratingTokens, from: '#667eea', to: '#764ba2' },
  { key: 'submitted',   label: 'Submitted',      icon: MdOutlinePending,          from: '#94a3b8', to: '#475569' },
  { key: 'in_progress', label: 'In Progress',    icon: MdAutorenew,               from: '#f093fb', to: '#f5576c' },
  { key: 'closed',      label: 'Completed',      icon: MdDone,                    from: '#4facfe', to: '#00f2fe' },
];

const RequestUserAccount = () => (
  <RequestStatsDashboard
    title="User Account Requests"
    subtitle="Manage and track all user account creation requests"
    Icon={FaUserShield}
    accent="#6366f1"
    thunk={getRequestUserAccounts}
    statusCards={STATUS_CARDS}
    categoryTitle="Top Reasons"
    categorySubtitle="Requests by purpose"
  />
);

export default RequestUserAccount;
